import React, { Component } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

export default class Modal extends Component {
  render() {
    return ReactDOM.createPortal(
      <Portal>
        <Wrapper>{this.props.children}</Wrapper>
      </Portal>,
      document.body
    );
  }
}

const Portal = styled.div`
  background-color: ${props => props.theme.mask};
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;
// z-index: 10

const Wrapper = styled.div`
  padding: 20px;
  border-radius: 4px;
  border-top: 6px solid ${props => props.theme.blueButton};
  background-color: white;
  overflow-y: auto;
  overflow-x: hidden;
`;



// WEBPACK FOOTER //
// ./src/module-common/Modal.js